import React from 'react';
import {
    Box,
    Button,
    FlexBox,
    Link,
    PipeSeparator,
    Section,
    Typography,
    tokens,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { LinkMenu } from '../LinkMenu/LinkMenu';
import { Status } from '../Status/Status';

export interface TopbarProps {
    status: React.ComponentProps<typeof Status>;
    navUrl: string;
    navLabel: string;
    onLinkMenuChange?: () => void;
    menuProps: React.ComponentProps<typeof LinkMenu>;
    children?: React.ReactNode;
}

const TopbarOuter = styled.div`
    background-color: ${tokensRaw.SwanBaseColorWhite};
    border-bottom: 1px solid ${tokensRaw.SwanBaseColorGrey300};
    padding: ${tokens.SwanSemSpace6} ${tokens.SwanSemSpace7} ${tokens.SwanSemSpace6}
        ${tokens.SwanSemSpace5};
    width: 100%;
`;

const TopbarInner = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TopbarDesktop: React.FC<TopbarProps> = ({
    status,
    onLinkMenuChange,
    menuProps,
    navLabel,
    navUrl,
    children,
}) => {
    return (
        <Box compactMode>
            <TopbarOuter>
                <TopbarInner>
                    <FlexBox
                        alignItems="center"
                        gap="2"
                        flexWrap="wrap"
                        justifyContent="flex-start"
                    >
                        <Button
                            skin="tertiary"
                            render={(props) => (
                                <Link to={navUrl} className={props.className}>
                                    {props.children}
                                </Link>
                            )}
                        >
                            {navLabel}
                        </Button>
                        <Typography textColor={'subtle'}>—</Typography>
                        <LinkMenu
                            label={menuProps.label}
                            links={menuProps.links}
                            onChange={onLinkMenuChange}
                        />
                        <PipeSeparator />
                        <Status {...status} />
                    </FlexBox>
                    {children && <Section>{children}</Section>}
                </TopbarInner>
            </TopbarOuter>
        </Box>
    );
};

export const Topbar: React.FC<TopbarProps> = (props) => {
    // TODO: Add mobile view
    return <TopbarDesktop {...props} />;
};
